export enum DisplayType {
  PERCENT = "PERCENT",
  GROSS = "GROSS",
}
